export default __webpack_public_path__ + "static/media/Version (1) - Early Prop_16.2221225a.jpg";